import { render } from "./YearPage.vue?vue&type=template&id=04fbc9db"
import script from "./YearPage.vue?vue&type=script&lang=js"
export * from "./YearPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__